<script setup>
import { onMounted } from "vue";
import env from "@/env.js";

const { redirectUriPath, scanState, scanAppid, scanRedirectUri, selfRedirect } = defineProps({
  selfRedirect: { type: Boolean, default: false },
  scanState: { type: String, default: "" },
  scanAppid: { type: String, default: "" },
  scanRedirectUri: { type: String, default: "" },
  redirectUriPath: {
    type: String,
    required: true,
  },
});

const appid =
  env.host === "https://bihai.life"
    ? "wx3a39c5b4b8b28586"
    : "wx6a1bc4dc760f5f24";

const generateState = () =>
  Math.random().toString(36).substring(2, 15) +
  Math.random().toString(36).substring(2, 15);

const getCustomStyle = () =>
  "data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5xcmNvZGUgew0KICB3aWR0aDogMjAwcHg7DQogIGhlaWdodDogMjAwcHg7DQogIG1hcmdpbjogMCBhdXRvOw0KfQ==";

const initWechatLogin = () => {
  if (!window.WxLogin) return;

  const redirectUri = encodeURIComponent(scanRedirectUri || env.host + redirectUriPath);
  new window.WxLogin({
    self_redirect: selfRedirect,
    id: "wx-login-container",
    appid: scanAppid || appid,
    scope: "snsapi_login",
    redirect_uri: redirectUri,
    state: scanState || generateState(),
    style: "black",
    href: getCustomStyle(),
  });
};

onMounted(() => {
  initWechatLogin();
});
</script>

<template>
  <div id="wx-login-container" class="wx-login-container"></div>
</template>

<style scoped>
.wx-login-container {
  width: 300px;
  height: 340px;
  margin: 0 auto;
}
</style>
